import { styled } from "../../theme";
import { MediaImage } from "../../types";

export const Container = styled.div<{ bg?: MediaImage | string }>`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  min-width: 100%;
  min-height: 100%;
  background: ${({ bg }) => (bg ? (typeof bg === "string" ? bg : `url("${bg.url}")`) : "none")};
  background-size: cover;
  background-position: center;
  -webkit-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  -moz-box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);
  box-shadow: 10px 10px 28px -4px rgba(0, 0, 0, 0.8);

  @media (max-width: ${({ theme }) => theme.mobileFirst.breakPoint}) {
    box-sizing: border-box;
    max-height: initial;
    height: initial;
    &.base-activity_storyline {
      height: 100%;
    }
    background: ${({ bg }) =>
      bg ? (typeof bg === "string" ? bg : `url("${bg.mobileUrl ? bg.mobileUrl : bg.url}")`) : "none"};
  }
`;
